module.exports = __webpack_public_path__ + "static/img/08.2d9f3b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/08.png
// module id = eCis
// module chunks = 37